import script from "./realtime-virus-alert-panel.vue?vue&type=script&lang=ts&setup=true"
export * from "./realtime-virus-alert-panel.vue?vue&type=script&lang=ts&setup=true"

import "./realtime-virus-alert-panel.vue?vue&type=style&index=0&id=4605139a&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4605139a"]])

export default __exports__